// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\"> <path fill=\"#4A4A4A\" fill-rule=\"evenodd\" d=\"M16 0v16H0V0h16zm-2 2H2v12h12V2zM6.5 4C7.88 4 9 5.12 9 6.5S7.88 9 6.5 9 4 7.88 4 6.5 5.12 4 6.5 4z\"/> </svg> ";
// Exports
module.exports = code;